module.exports = __webpack_public_path__ + "static/media/launchscreen-bg.6dd3150e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/launchscreen-bg.png
// module id = 646
// module chunks = 0